import React from 'react';
import { DoNotCallList } from '../../../../../../../types/do-not-call-list';
import TruncatedTextWithTooltip from '../../../../../../../../../shared/components/truncated-text-with-tooltip';

type IProps = {
  doNotCallList: DoNotCallList;
};

const ListNameField: React.FC<IProps> = ({ doNotCallList: { name } }) => (
  <TruncatedTextWithTooltip
    length={50}
    string={name}
    textClassName="list-name-field"
    tooltipClassName="tooltip-xxl"
  />
);

export default ListNameField;
